import styled from "styled-components/macro";

export const StyledDocumentSharingMenu = styled.div`
  #document-sharing-container {
    position: relative;

    & > a svg {
      padding-bottom: 3px;
    }
  }

  .clean-copy-onboarding {
    width: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    header {
      align-items: center;
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    footer {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 15px;
      width: 100%;

      p {
        text-align: right;
        margin: 0px;
      }
    }

    h1 {
      margin: 0px; // override app.scss
      margin-top: 8px;
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 8px;
    }

    .onboarding-gif-container {
      width: 100%;
      border-radius: 10px;
      overflow: hidden;

      video {
        width: 100%;
      }
    }
  }

  .close {
    position: absolute;
    cursor: pointer;
    top: 10px;
    right: 10px;
    width: 25px;
    height: 25px;

    path {
      fill: var(--grey-2);
    }
  }

  .document-sharing-menu {
    cursor: default;
    padding: 18px;
    background: var(--menu-color-fullscreen);
    box-shadow: var(--default-drop-shadow);
    border-radius: 18px;
    position: absolute;
    top: 46px;
    right: -30px;
    z-index: 100000;

    color: var(--grey-0);
    max-height: calc(min(80vh, 500px));
    font-size: 14px;
    font-weight: 500;
    text-align: initial;
    min-width: 300px;
    max-width: min(500px, 90vw);
    width: max-content;

    &::before {
      content: "";
      position: absolute;
      top: -10px;
      right: 35px;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      border-bottom: 15px solid var(--menu-color-fullscreen);
      width: 0;
      height: 0;
      background-color: transparent;
    }

    h1:first-of-type {
      margin-top: 0px;
    }

    h1 {
      margin: 0px; // override app.scss
      margin-top: 8px;
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 8px;
    }

    h1:nth-of-type(2) {
      margin-top: 24px;
      margin-bottom: 10px;
    }

    p {
      line-height: 20px;
      color: var(--grey-1);
      margin-bottom: 16px;
    }
  }
`;

export const ErrorMessage = styled.div`
  color: var(--danger-color);
  background-color: var(--danger-color-hover);
  border: solid 1px var(--danger-color);
  border-radius: 8px;
  padding: 0.618em;
  margin-bottom: 0.618em;
`;

export const ShareLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 20001;
`;
